import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { getValue } from 'remote-config-value'
import { makeStyles } from '@material-ui/core/styles'
import { email, regex, required } from 'validation-rules'
import { TextField } from 'foundations-library/components'
import StepTitle from '../../StepTitle'
import useFlatForm from '../../../hooks/useFlatForm'
import useDisableInput from '../../../hooks/useDisableInput'

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 30
    },
    twoInputsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 10
    }
}))

/**
 * @param {object} props
 */
const Contact = (props) => {
    const classes = useStyles()
    const campaignContactSavedData = props.passData.campaign_contact
    const { editing } = props
    const { disableAllInputs } = useDisableInput({ mode: props.mode, item: props.editing })

    const {
        data,
        onClear,
        setDataProp,
        setIsValidProp,
        isFormDataValid
    } = useFlatForm({
        name: campaignContactSavedData ? campaignContactSavedData.name : (editing != null ? editing.contact_name : ''),
        email: campaignContactSavedData ? campaignContactSavedData.email : (editing != null ? editing.contact_email : '')
    })

    useEffect(() => {
        if (props.saveId) props.update?.({ completed: true, gotoNext: true, saveData: data })
    }, [props.saveId])

    useEffect(() => {
        props.update?.({ disableNextButton: () => !isFormDataValid })
    }, [isFormDataValid])

    return (
        <div>
            <StepTitle remoteConfigID='sms_enrollment_campaigns_4th_step_title' />
            <div className={classes.container}>
                <TextField
                    id='nameTxtField'
                    disabled={disableAllInputs}
                    label={getValue('sms_enrollment_enter_name')}
                    value={data.name}
                    onChange={setDataProp('name')}
                    isValid={setIsValidProp('name')}
                    onClear={onClear('name')}
                    rules={[required(), regex(new RegExp("^[\\p{L}\\s'-]+$", 'u'))]}
                    helperText={getValue('sms_enrollment_campaigns_4th_step_name_helper')}
                />
                <TextField
                    id='emailTxtField'
                    disabled={disableAllInputs}
                    label={getValue('sms_enrollment_enter_email')}
                    value={data.email}
                    onChange={setDataProp('email')}
                    onClear={onClear('email')}
                    helperText={getValue('sms_enrollment_campaigns_4th_step_email_helper')}
                    rules={[required(), email()]}
                    isValid={setIsValidProp('email')}
                />
            </div>
        </div>
    )
}

Contact.propTypes = {
    passData: PropTypes.object,
    update: PropTypes.func,
    saveId: PropTypes.number,
    editing: PropTypes.object,
    showTitle: PropTypes.bool,
    showContainer: PropTypes.bool,
    mode: PropTypes.string
}

export default Contact
